// shared/lib 배럴이 아닌 구체 모듈에서 import — 배럴은 converter/utility 를 거쳐 shared/constants 를
// 되참조하는 순환이라, shared/lib 쪽에서 먼저 진입하면 이 시점에 createMapFromOptions 가 undefined 가 됨
import { createMapFromOptions } from 'shared/lib/map';

import { OCCUPATION_OPTIONS_V2 } from './options';

/**
 * @description Occupation ID를 Label로 매핑하는 Map 객체
 * @example
 * occupationMap['UNDERGRADUATE'] // 'Undergraduate Student'
 * occupationMap['GRADUATE'] // 'Graduate Student'
 */
export const OCCUPATION_MAP = createMapFromOptions(OCCUPATION_OPTIONS_V2);
